import { callFunction } from './callableClient'
import type { PartnerTicket, PartnerTicketCategory } from '../types/partnerTicket'

export async function createPartnerTicket(input: {
  category: PartnerTicketCategory
  subject: string
  description: string
  relatedTaskId?: string
}): Promise<PartnerTicket> {
  const result = await callFunction<
    {
      category: PartnerTicketCategory
      subject: string
      description: string
      relatedTaskId?: string
    },
    { ticket: PartnerTicket }
  >('partnerCreateTicket', input)
  return result.ticket
}

export async function listPartnerTickets(limit = 50): Promise<PartnerTicket[]> {
  const result = await callFunction<{ limit?: number }, { tickets: PartnerTicket[] }>(
    'partnerListTickets',
    { limit }
  )
  return result.tickets
}

export async function getPartnerTicketById(ticketId: string): Promise<PartnerTicket> {
  const result = await callFunction<{ ticketId: string }, { ticket: PartnerTicket }>(
    'partnerGetTicketById',
    { ticketId }
  )
  return result.ticket
}
